const addProduct = (data) => {
    return {
        type: "ADD_PRODUCT_DATA",
        data
    }
}

export { addProduct }